<template>
  <div class="activityOver">
    <div class="activityBg"></div>
    <div class="activityView">
      <p class="activityTatol">已有123123用户参与活动</p>
      <div class="shareBg">
        <p class="shareTitle">锦鲤</p>
        <div class="sharePost"></div>
        <p class="vowText">我想去#日本#欣赏那一年一度的 樱花盛开的美景。</p>
      </div>
      <div class="nextView">
        <p class="nextText">本期祈福武汉结束</p>
        <div>
          <p class="nextText">未完待续</p>
          <p class="nextText">下期活动...2020/1/10</p>
        </div>

      </div>
    </div>
  </div>
</template>
<script lang="ts">
import Vue from "vue";
export default Vue.extend({
  name: "ActivityOver",
  data() {
    return {};
  },
  methods: {},
  mounted() {}
});
</script>
<style scoped lang="scss" src="../../static/scss/activityover.scss"></style>
<style scoped lang="scss">
@import "../../static/scss/var.scss";
</style>
